<template>
    <v-row justify="center">
    <v-dialog
        v-model="component.taxOperationTypeErrorDialog"
        width="430"
        >

        <v-card text-center>
            <v-card-title class="text-h6 grey lighten-2">
            Tipo de Operação Fiscal Não Cadastrado!
            </v-card-title>

            <v-card-text style="font-size: 18px;">
            Verifique se o tipo de operação fiscal 999 está cadastrado
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="component.taxOperationTypeErrorDialog = false"
            >
                Ok
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    props: {
      component: Object,
    },
  };
</script>